import { Component, OnInit, Input } from '@angular/core';
import { Shared } from '../shared.service';
import * as _ from "lodash";


@Component({
  selector: 'menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss']
})
export class MenuItemComponent implements OnInit {

  active = false;
  name;
  cannabinoids = [];
  tiers = [];
  key;
  type;
  @Input() product;
  cannab;
  canSee = false;
  product_copy;
  sale;

  constructor(public shared: Shared) {
  }

  getSale(tier){
      if(this.product_copy.sale.active){
          switch(this.product_copy.sale.measurement){
              case '$':
                  return Number(this.product_copy.sale.value);
              case '%':
                  return tier.price * (Number(this.product_copy.sale.value)/100);
              default:
                  return 0;
          }
      } else if(this.shared.noGlobalSale){
          return 0;
      } else {
          switch(this.shared.globalSale.measurement){
              case '$':
                  return Number(this.shared.globalSale.value);
              case '%':
                  return tier.price * (Number(this.shared.globalSale.value)/100);
              default:
                  return 0;
          }
      }
  }

  ngOnInit() {
      this.product_copy = _.cloneDeep(this.product);
      ////console.log(this.product_copy);
      this.key = this.product.$key;
  }
  isSoldOut(tier){
      if(tier.soldOut === undefined){
          return false;
      }
      return tier.soldOut[this.shared.firebase_user.location] === true;
  }

  toggleSoldOut(tier){
      let soldOut: Object = tier.soldOut;
      let loc = this.shared.firebase_user.location;
      if(tier.soldOut){
          if(soldOut.hasOwnProperty(this.shared.firebase_user.location)){
              tier.soldOut[loc] = !tier.soldOut[loc];
          } else {
              tier.soldOut[loc] = true;
          }
          console.log(this.product_copy);
      } else {
        tier['soldOut'] = {};
        tier.soldOut[loc] = true;
      }
      delete this.product_copy['$key'];
      this.shared.productsRef.update(this.product.$key, this.product_copy);
  }
  deleteChanges(event){
      ////console.log(Object.keys(event['cannabinoids']).length, Object.keys(this.product['cannabinoids']).length);
      this.product_copy = _.cloneDeep(this.product);
  }

  canView(){
      return this.product.locations[this.shared.firebase_user.location];
  }

  seeTier(tier){
      if(tier.price === ''){
          this.canSee = true;
          return false;
      } else {
          this.canSee = false;
          return true;
      }
  }

  buildArr(objects){
      let arr = [];
      Object.keys(this.product_copy[objects]).map((key) => {
          arr.push(this.product_copy[objects][key]);
      });
      return arr;
  }

  toggleActive(){
    this.active = !this.active;
  }

}



// WEBPACK FOOTER //
// ./src/app/menu-item/menu-item.component.ts